/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：216
 */

module.exports = require(/* 1074 */"../1580/1074")
